export default class Accordion {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.accordion:not(.accordion--in-backend)'), el => {
			new Accordion(el);
		});
	}

	items = [];
	classes = {
		node: 'accordion',
		item: 'accordion__item',
	}

	constructor(element) {
		if (!element) return;
		this.node = element;
		this.items = this.parseItems();
	}

	getActiveItem() {
		return this.items.find(el => el.isActive);
	}

	parseItems() {
		let itemsArray = [];
		let items = this.node.querySelectorAll('.' + this.classes.item);
		Array.prototype.forEach.call(items, (item) => {
			itemsArray.push(new AccordionItem(this, item));
		});

		return itemsArray;
	}
}

class AccordionItem {
	id = 'accordion__item--hash-' + Math.random().toString(36).substr(2, 5);
	activeContentOffset = 30; // paddings for content
	classes = {
		active: 'accordion__item--is-active',
		title: 'accordion__item-title',
		content: 'accordion__item-content'
	}

	constructor(main, element) {
		if (!element) return;
		this.node = element;
		this.main = main;
		this.titleNode = element.querySelector('.' + this.classes.title);
		this.contentNode = element.querySelector('.' + this.classes.content);
		this.isActive = this.node.classList.contains(this.classes.active);

		if (this.isActive) this.open();

		this.titleNode.addEventListener('click', () => {
			let activeItem = this.main.getActiveItem();
			if (activeItem) {
				activeItem.close();
				if (this.id === activeItem.id) return;
			}
			this.open();
		});
	}

	open() {
		this.isActive = true;
		this.node.classList.add(this.classes.active);
		this.contentNode.style.maxHeight = this.contentNode.scrollHeight + this.activeContentOffset + "px";
		this.scrollToItem();
	}

	close() {
		this.isActive = false;
		this.contentNode.style.maxHeight = 0;
		this.node.classList.remove(this.classes.active);
	}

	scrollToItem() {
		setTimeout(() => {
			let headerHeight = document.getElementById('header').getBoundingClientRect().height;
			let windowPosition = window.pageYOffset;
			let itemPosition = this.node.getBoundingClientRect().top;
			let itemOffset = this.titleNode.getBoundingClientRect().height;

			window.scrollTo({
				top: windowPosition + itemPosition - itemOffset - headerHeight,
				behavior: 'smooth',
			});
		}, 200);
	}
}
